"use client";

import * as React from 'react';
import Button from '../button';
const PickerButton = props => (/*#__PURE__*/React.createElement(Button, Object.assign({
  size: "small",
  type: "primary"
}, props)));
export default PickerButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/date-picker/PickerButton.js
// module id = 1877
// module chunks = 0